module.exports = "<div *ngIf=\"!!error\">\n  <section class=\"error-block-info\">\n    <div class=\"row\">\n      <div class=\"small-12 medium-12 columns\">\n        <div class=\"error-block-info__code\">\n          {{ error.code }}\n        </div>\n        <div class=\"error-block-info__text\">\n          {{ error.message }}\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n\n<div *ngIf=\"!error\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors/error.component.html
// module id = 364
// module chunks = 0